import { render } from "./FormGlazingDimensions.vue?vue&type=template&id=1eb5f6f4"
import script from "./FormGlazingDimensions.vue?vue&type=script&lang=js"
export * from "./FormGlazingDimensions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__